import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { HeaderImageType } from "src/app/constants/header-image-type.constants";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";

@Component({
	selector: "app-announcement",
	templateUrl: "./announcement.component.html",
	styleUrls: ["./announcement.component.css"]
})
export class AnnouncementComponent implements OnInit {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService,
		public sanitizer: DomSanitizer,
		public dmvStoreService: DMVStoreService
	) {}

	ngOnInit() {
		this.globalService.updateHeaderImageType(HeaderImageType.DEFAULT);

		this.globalService.isAnnouncementFlow = false;
		this.globalService.isAnnouncementVisible = true;
		this.globalService.setAnnouncementPageVisible(true);
	}
	public back() {
		this.globalService.setAnnouncementPageVisible(false);
		if (this.globalService.routerLastUrl === "/home") {
			this.router.navigate(["/county-landing"], { skipLocationChange: true });
		} else {
			this.router.navigate([this.globalService.routerLastUrl], {
				skipLocationChange: true
			});
		}
	}
}
